export default __webpack_public_path__ + "static/universlt-light-172906a526879997d45999484cf606d1.woff";